import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import {
  getMarketplaceInteractionEvent,
  type MarketplaceInteraction,
} from 'marketplace-ui-tracking/events/marketplace';
import { useEffect, useRef } from 'react';
import { Screens } from '../constants/usage';

type UseTrackProxyRedirectProps = {
  filterType?: string;
  filterValue?: string[];
  filters: string[];
  loading: boolean;
  pageNumber?: number;
  skip?: boolean;
  subscreen: string;
  type: NonNullable<MarketplaceInteraction['type']>;
};

export function useTrackProxyRedirect({
  filterType,
  filterValue,
  filters,
  loading,
  pageNumber,
  skip,
  subscreen,
  type,
}: UseTrackProxyRedirectProps) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!loading && !skip && !firedRef.current) {
      firedRef.current = true;
      trackMarketplaceEvent(
        getMarketplaceInteractionEvent({
          action: 'proxy redirect',
          filters,
          ...(filterType !== undefined && { filterType }),
          ...(filterValue !== undefined && { filterValue }),
          ...(pageNumber !== undefined && { pageNumber }),
          referrer: document.referrer,
          screen: Screens.PROXY_REDIRECT,
          subscreen,
          type,
        })
      );
    }
  }, [
    filterType,
    filterValue,
    filters,
    loading,
    pageNumber,
    skip,
    subscreen,
    trackMarketplaceEvent,
    type,
  ]);
}
